var _a;
import { $$, $e, $hidden, csrfToken, on, inputs, $1, $n } from './utils';
// debug
if (((_a = $1('meta[name="app.env"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('value')) !== 'production') {
    on('click', '[type=submit],button:not([type])', function (ev) {
        if (ev.ctrlKey)
            ev.currentTarget.formNoValidate = true;
    });
}
// data-confirm
on('click', '[data-confirm]', function (ev) {
    if (!confirm(ev.currentTarget.dataset.confirm)) {
        ev.stopImmediatePropagation();
        ev.preventDefault();
    }
});
// data-method
function processMethod(action, method) {
    var form = $e('form', { action: action, method: 'post' });
    form.append($hidden('_token', csrfToken()));
    if (method && method.toLowerCase() !== 'post') {
        form.append($hidden('_method', method.toLowerCase()));
    }
    document.body.append(form);
    form.submit();
}
on('click', 'a[data-method]', function (ev) {
    var elem = ev.currentTarget;
    ev.stopImmediatePropagation();
    ev.preventDefault();
    processMethod(elem.href, elem.dataset.method);
});
// data-change-refresh
on('change', '[data-change-refresh]', function (ev) {
    var elem = ev.currentTarget;
    var url = new URL(elem.dataset.changeRefresh || location.href);
    url.searchParams[elem.value ? 'set' : 'delete'](elem.name, elem.value);
    location.href = url.toString();
});
// data-scroll-enable
function handleScrollEnable(ev) {
    var elem = ev.currentTarget;
    if (Math.abs(elem.scrollHeight - elem.clientHeight - elem.scrollTop) < 1) {
        document.querySelectorAll(elem.dataset.scrollEnable).forEach(function (e) { return (e.disabled = false); });
        elem.removeEventListener('scroll', handleScrollEnable);
    }
}
$$('[data-scroll-enable]').forEach(function (elem) {
    elem.addEventListener('scroll', handleScrollEnable);
});
// data-enable-on
function handleEnableOn(elem) {
    var targets = undefined;
    if (elem.dataset.enableOn) {
        var checked = elem.dataset.enableValue
            ? elem.dataset.enableValue.split(',').includes(elem.value)
            : elem.dataset.enableSince
                ? elem.dataset.enableSince <= elem.value
                : elem.dataset.enableUntil
                    ? elem.dataset.enableUntil >= elem.value
                    : elem.checked;
        var enabled_1 = elem.dataset.negate ? !checked : checked;
        targets = enableOnTargets(elem);
        targets === null || targets === void 0 ? void 0 : targets.forEach(function (e) { return setDisabled(e, !enabled_1); });
    }
    if (elem.type === 'radio' && !elem.dataset.enableValue) {
        inputs(elem).forEach(function (radio) {
            var _a;
            if (radio.checked)
                return;
            (_a = enableOnTargets(radio)) === null || _a === void 0 ? void 0 : _a.forEach(function (e) {
                if (!(targets === null || targets === void 0 ? void 0 : targets.includes(e)))
                    setDisabled(e, true);
            });
        });
    }
}
function enableOnTargets(elem) {
    if (!elem.dataset.enableOn)
        return;
    return Array.from($$(elem.dataset.enableOn.replace('@@value', elem.value)));
}
function setDisabled(elem, disabled) {
    if (elem.tagName === 'FIELDSET') {
        // Safari Bug; cf. https://stackoverflow.com/questions/36282308/cant-enable-html-input-fields-in-safari
        var subs = Array.from(elem.querySelectorAll('[disabled]'));
        subs.forEach(function (e) { return (e.disabled = false); });
        elem.disabled = disabled;
        subs.forEach(function (e) { return (e.disabled = true); });
    }
    else {
        elem.disabled = disabled;
    }
}
on('change', 'input[type=radio],[data-enable-on]', function (ev) { return handleEnableOn(ev.currentTarget); });
$$('[data-enable-on]:not([type=radio]:not(:checked))').forEach(function (elem) { return handleEnableOn(elem); });
// data-calculate-deposit
function calculateDeposit(elem) {
    var value = parseInt(elem.dataset.calculateDeposit, 10) - parseInt(elem.value, 10);
    $1(elem.dataset.calculateOut).value = Number.isNaN(value) ? '-' : $n(value);
}
on('input', '[data-calculate-deposit]', function (ev) { return calculateDeposit(ev.currentTarget); });
$$('[data-calculate-deposit]').forEach(calculateDeposit);
// password with autocomplete="off"
$$('[type=password][autocomplete=off]').forEach(function (elem) {
    Object.assign(elem, { value: '', autocomplete: 'new-password' });
    setTimeout(function () { return (elem.autocomplete = 'off'); }, 1);
});
// data-calculate-discount
function calculateDiscount(elem) {
    var elem1 = $1('#price').value;
    var elem2 = $1('#deposit').value;
    var elem3 = $1('#loan_amount').value;
    var value = parseInt(elem1, 10) - parseInt(elem2, 10) - parseInt(elem3, 10);
    $1(elem.dataset.calculateOut).value = Number.isNaN(value) ? '-' : $n(value);
}
on('input', '[data-calculate-discount]', function (ev) { return calculateDiscount(ev.currentTarget); });
$$('[data-calculate-discount]').forEach(calculateDiscount);
